import { Fragment, useState, useEffect, form } from "react";
import { TitleHeader, InputAntd, ButtonHelp } from "../../components/commons";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Checkbox,
  Spin,
  Result,
  notification,
  Alert,
  message
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { getFormData, updateOne } from "../../api/participante";
import {
  getFacultades,
  getOficinas,
  getCondicionesContrato,
  getDepartamentosAcademicos,
  getLugaresExamenes,
  getSemestres,
  getEspecialidades,
  getCarreras,
  downloadPDF,
  getAsignaturas,
  getGradoAcademico
} from "../../api/sistema";
import * as SHARED from "../../utils/shared";
import { ACCESS_TOKEN } from "../../api/auth";
import { BASE_PATH, API_VERSION } from "../../api/api";

const { Option } = Select;
const DNI = 1;
const CARNET_DE_EXTRANJERIA = 2;
const MAX_LENGTH_DNI = 8;
const MAX_LENGTH_CE = 12;
const REGEX_NUMBERS = "^[0-9]+$";
const REGEX_NUMS_AND_LETTERS = "^[a-zA-Z0-9]+$";

function Formulario() {
  const [data, setData] = useState({
    payload: {
      idtipoparticipante: "",
      apellido: "",
      nombre: "",
      idcondicioncontrato: "",
      iddepacademico: "",
      idfacultad: "",
      nrocelular: "",
      nrodocumento: "",
      idestado: "",
      acceptTerms: "",
      idsemestre: "",
      idespecialidad: "",
      coduniversitario: "",
      idoficina: "",
      nombretitulo: "",
      nombrejefe: "",
      nrocelularjefe: "",
      fechafincontrato: ""
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const [facultades, setFacultades] = useState([{ idfacultad: "", nombre: "" }]);
  const [oficinas, setOficinas] = useState([{ idoficina: "", nombre: "" }]);

  const [condicionesContrato, setCondicionesContrato] = useState([
    { idcondicioncontrato: "", nombre: "" }
  ]);

  const [departamentosAcademicos, setDepartamentosAcademicos] = useState([
    { iddepacademico: "", nombre: "" }
  ]);

  const [gradoAcademico, setGradoAcademico] = useState([{ idgradoacademico: "", nombre: "" }]);

  const [semestres, setSemestres] = useState([{ idsemestre: "", nombre: "" }]);
  const [especialidades, setEspecialidades] = useState([{ idespecialidad: "", nombre: "" }]);
  const [carreras, setCarreras] = useState([{ idcarrera: "", nombre: "" }]);
  const [asignatura, setAsignatura] = useState([{ idasignatura: "", nombre: "" }]);
  const [lugarExamen, setLugarExamen] = useState([{ idlugarexamen: "", nombre: "" }]);
  const [tipoDocumento, setTipoDocumento] = useState(DNI);

  const [disableTitulo, setDisableTitulo] = useState(false);
  const [selectedContrato, setSelectedContrato] = useState(null);

  useEffect(() => {
    getFormParticipante();
  }, []);

  const getFormParticipante = async () => {
    try {
      setIsLoading(true);
      const response = await getFormData();
      setData(response.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const history = useHistory();

  useEffect(() => {
    if (data?.nombretitulo === "SIN TITULO") {
      setDisableTitulo(true);
    }
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getFacultades();
      setFacultades(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getOficinas();
      setOficinas(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getGradoAcademico();
      setGradoAcademico(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getCondicionesContrato();
      setCondicionesContrato(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getDepartamentosAcademicos();
      setDepartamentosAcademicos(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getLugaresExamenes();
      setLugarExamen(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSemestres();
      setSemestres(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getEspecialidades();
      setEspecialidades(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getCarreras();
      setCarreras(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAsignaturas();
      setAsignatura(response.payload);
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const prefixSelector = (
    <Form.Item name="tipoDocumento" noStyle initialValue={tipoDocumento}>
      <Select onSelect={(value) => setTipoDocumento(value)}>
        <Option value={DNI}>DNI</Option>
        <Option value={CARNET_DE_EXTRANJERIA}>C.E.</Option>
      </Select>
    </Form.Item>
  );

  // ------------- Descarga ganadores por codigo -------------
  const descargarDeclaracionJurada = async () => {
    function getFileByTipoParticipante() {
      if (
        data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO &&
        data.idtipoparticipacion === SHARED.ID_SUPERVISION
      ) {
        return "dj_administrativo_apoyo.pdf";
      }

      if (
        data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO &&
        data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO
      ) {
        return "dj_administrativo_internamiento.pdf";
      }

      if (
        data.idtipoparticipante === SHARED.ID_DOCENTE &&
        data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO
      ) {
        return "dj_docente_elaborador.pdf";
      }

      if (data.idtipoparticipante === SHARED.ID_ESTUDIANTE) {
        return "dj_estudiante.pdf";
      }

      if (data.idtipoparticipacion === SHARED.ID_SUPERVISION) {
        return "dj_supervisor_aula.pdf";
      }

      return "";
    }

    const tipoDeArchivo = getFileByTipoParticipante();
    const blob = await downloadPDF(tipoDeArchivo);

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", tipoDeArchivo);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const onFormSubmit = async (formValues = {}) => {
    const body = {
      apellido: formValues.apellido,
      nombre: formValues.nombre,
      idcondicioncontrato: formValues.idcondicioncontrato,
      iddepacademico: formValues.iddepacademico,
      idfacultad: formValues.idfacultad,
      nrocelular: formValues.nrocelular,
      nrodocumento: formValues.nrodocumento,
      idestado: SHARED.ID_ESTADO_PENDIENTE,
      acceptTerms: formValues.acceptTerms,
      idsemestre: formValues.idsemestre,
      idespecialidad: formValues.idespecialidad,
      idcarrera: formValues.idcarrera,
      coduniversitario: formValues.coduniversitario,
      idoficina: formValues.idoficina,
      idasignatura: formValues.idasignatura,
      participafecha1: formValues.participafecha1,
      participafecha2: formValues.participafecha2,
      idgradoacademico: formValues.idgradoacademico,
      idlugarexamen: formValues.idlugarexamen,
      nombretitulo: disableTitulo ? "SIN TITULO" : formValues.nombretitulo,
      nombrejefe: formValues.nombrejefe,
      nrocelularjefe: formValues.nrocelularjefe,
      fechafincontrato: formValues.fechafincontrato
        ? new Date(`${formValues.fechafincontrato}T00:00:00`)
        : null
    };

    if (!formValues.acceptTerms) {
      return openNotificationWithIcon("error", "Es necesario aceptar los términos.");
    }

    // if (data.idtipoparticipante !== SHARED.ID_ESTUDIANTE) {
    //   if (!formValues.participafecha1 && !formValues.participafecha2) {
    //     return openNotificationWithIcon(
    //       "error",
    //       "Es necesario seleccionar al menos una fecha de participación."
    //     );
    //   }
    // }

    try {
      const res = await updateOne(body, data._id);
      openNotificationWithIcon("success", res.message);
      history.push(SHARED.PATH_INSCRIPCION);
    } catch (err) {
      openNotificationWithIcon("error", err.message);
    }
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message
    });
  };

  const onFinishFailed = ({ values }) => {
    if (values) {
      openNotificationWithIcon("error", "Faltan completar campos");
    }
  };

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const ShowAlertByUrlOk = (props) => {
    const { itHasUrl, isUrlOk } = props;

    if (!itHasUrl) {
      return "";
    }

    if (itHasUrl && isUrlOk === null) {
      return <Alert message="Adjuntado" type="info" showIcon />;
    }

    if (isUrlOk) {
      return <Alert message="Aceptado" type="success" showIcon />;
    }

    return <Alert message="Observado" type="error" showIcon />;
  };

  const uploadDocument = (type = "", nrodocumento = null, maxSize = 10, maxSizeImage = 3) => {
    return uploadProps({
      name: "attached",
      action: "/sistema/upload-files",
      data: { type, nrodocumento },
      maxSize,
      maxSizeImage
    });
  };

  const uploadProps = (body) => {
    const { name = "", action = "", data, maxSize = 10, maxSizeImage = 3 } = body;

    return {
      name,
      action: `${BASE_PATH}/${API_VERSION}${action}`,
      headers: { authorization: ACCESS_TOKEN },
      data,
      beforeUpload(file) {
        if (file.type === "image/jpeg") {
          const isLt3M = file.size / 1024 / 1024 <= maxSizeImage;
          if (!isLt3M) {
            message.error("El archivo debe pesar máximo 3Mb");
            return isLt3M;
          }
        }
        const isLt10M = file.size / 1024 / 1024 <= maxSize;
        if (!isLt10M) {
          message.error("El archivo debe pesar máximo 10Mb");
        }
        return isLt10M;
      },
      onChange(info) {
        if (info.file.status === "done") {
          message.success(`${info.file.name} subido correctamente`);
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} falló en subir.`);
        }
      }
    };
  };

  const handleCheck = (checked) => {
    setDisableTitulo(checked);
    if (checked) {
      form.setFieldsValue({ nombretitulo: "" });
    }
  };

  return (
    <Fragment>
      <TitleHeader title="" onBack={() => history.goBack()} />

      <div id="formulario" className="w-full md:w-4/5 lg:w-1/2 md:mx-auto">
        <p className="mb-4 text-lg font-bold text-blue-500">
          <span className="text-black">FORMULARIO DE INSCRIPCIÓN</span>
          <span className="text-gray-500">{` | `}</span>

          {data.tipoparticipante}
          <span className="text-gray-500">{` | `}</span>
          {data.tipoparticipacion}

          {data.tipoparticipante === "ESTUDIANTE" &&
            data.tipoparticipacion === "INTERNAMIENTO" &&
            " (ESTUDIANTE REGISTRADOR)"}
        </p>
        <Form layout="vertical" onFinish={onFormSubmit} onFinishFailed={onFinishFailed}>
          <div className="md:flex">
            <Form.Item
              label="Apellidos"
              name="apellido"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={data ? data.apellido : ""}
              rules={[{ required: true, message: "El apellido es requerido" }]}
            >
              <Input disabled />
            </Form.Item>

            <Form.Item
              label="Nombres"
              name="nombre"
              className="w-full md:w-1/2 md:ml-3"
              initialValue={data ? data.nombre : ""}
              rules={[{ required: true, message: "El nombre es requerido" }]}
            >
              <Input disabled />
            </Form.Item>
          </div>

          <div className="md:flex">
            <Form.Item
              label="Nro. de documento"
              name="nrodocumento"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={data ? data.nrodocumento : ""}
              // rules={[
              //   {
              //     required: true,
              //     message: "El campo nro. de documento es requerido"
              //   },
              //   {
              //     len: tipoDocumento === DNI && MAX_LENGTH_DNI,
              //     message: `La cantidad de dígitos debe ser ${MAX_LENGTH_DNI}`
              //   }
              // ]}
            >
              <InputAntd
                displayedValue={data ? data.nrodocumento : ""}
                maxLength={
                  (tipoDocumento === DNI && MAX_LENGTH_DNI) ||
                  (tipoDocumento === CARNET_DE_EXTRANJERIA && MAX_LENGTH_CE)
                } // dni: 8, ce: 12
                regex={
                  (tipoDocumento === DNI && REGEX_NUMBERS) ||
                  (tipoDocumento === CARNET_DE_EXTRANJERIA && REGEX_NUMS_AND_LETTERS)
                }
                addonBefore={prefixSelector}
                className="text-base h-9"
                disabled
              />
            </Form.Item>

            <Form.Item
              label="Número de celular"
              name="nrocelular"
              className="w-full md:w-1/2 md:ml-3"
              initialValue={data ? data.nrocelular : ""}
              rules={[
                {
                  required: true,
                  message: "El número de celular es requerido"
                }
              ]}
            >
              <Input placeholder="952000000" />
            </Form.Item>
          </div>

          {/* <div className="md:flex"> */}
          {data.idtipoparticipante === SHARED.ID_DOCENTE && (
            <Fragment>
              <Form.Item
                label="Condición de contrato"
                name="idcondicioncontrato"
                rules={[{ required: true, message: "La Condición de contrato es requerida" }]}
                className="w-full md:w-1/2 md:mr-3"
                initialValue={data ? data.idcondicioncontrato : ""}
              >
                <Select
                  placeholder="Seleccione la Condición de contrato"
                  onChange={(value) => setSelectedContrato(value)}
                  // defaultValue={data ? data.idcondicioncontrato : ""}
                >
                  {condicionesContrato.map((item) => (
                    <Option key={item.idcondicioncontrato} value={item.idcondicioncontrato}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Facultad"
                name="idfacultad"
                initialValue={data ? data.idfacultad : ""}
                rules={[{ required: true, message: "La Facultad es requerida" }]}
                className="w-full md:w-1/2 md:ml-3"
              >
                <Select
                  placeholder="Seleccione la facultad"
                  // defaultValue={data ? data.idfacultad : ""}
                >
                  {facultades.map((item) => (
                    <Option key={item.idfacultad} value={item.idfacultad}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Fragment>
          )}

          {data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO && (
            <Fragment>
              <div className="md:flex w-full">
                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <Form.Item
                    label="Especialidad"
                    name="idespecialidad"
                    className="w-full md:w-1/2"
                    initialValue={data ? data.idespecialidad : ""}
                    rules={[
                      {
                        required: true,
                        message: "La especialidad es requerida"
                      }
                    ]}
                  >
                    <Select
                      placeholder="Seleccione la espelialidad"
                      // defaultValue={data ? data.idcondicioncontrato : ""}
                    >
                      {especialidades.map((item) => (
                        <Option key={item.idespecialidad} value={item.idespecialidad}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </div>

              <div className="md:flex gap-4">
                <Form.Item
                  label="Condición de contrato"
                  name="idcondicioncontrato"
                  rules={[{ required: true, message: "La Condición de contrato es requerida" }]}
                  className="w-full md:w-1/2"
                  initialValue={data ? data.idcondicioncontrato : ""}
                >
                  <Select
                    placeholder="Seleccione la Condición de contrato"
                    onChange={(value) => setSelectedContrato(value)}
                    //disabled
                    // defaultValue={data ? data.idcondicioncontrato : ""}
                  >
                    {condicionesContrato.map((item) => (
                      <Option key={item.idcondicioncontrato} value={item.idcondicioncontrato}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* <Form.Item
                  label="Fecha de culminación de contrato"
                  name="fechafincontrato"
                  className="w-full md:w-1/2 md:ml-3"
                  initialValue={data?.fechafincontrato || ""}
                  rules={[
                    {
                      required: Number(selectedContrato) !== 2,
                      message: "Ingrese la fecha de culminación de contrato"
                    }
                  ]}
                >
                  <Input type="date" disabled={Number(selectedContrato) === 2} />
                </Form.Item> */}

                <Form.Item
                  label="Grado académico"
                  name="idgradoacademico"
                  initialValue={data ? data.idgradoacademico : ""}
                  className="w-full md:w-1/2"
                >
                  <Select placeholder="Seleccione el grado académico">
                    {gradoAcademico.map((item) => (
                      <Option key={item.idgradoacademico} value={item.idgradoacademico}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="md:flex w-full">
                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <Form.Item
                    label="Denominación del título profesional"
                    name="nombretitulo"
                    className="w-full md:w-1/2"
                    initialValue={data?.nombretitulo === "SIN TITULO" ? "" : data?.nombretitulo}
                    rules={[
                      { required: !disableTitulo, message: "El nombre del título es requerido" }
                    ]}
                  >
                    <Input
                      placeholder="nombre completo del título"
                      disabled={disableTitulo}
                      onChange={(e) => disableTitulo && (e.target.value = "")}
                    />
                  </Form.Item>
                )}

                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <div className="w-full justify-end flex items-center md:w-1/2 md:ml-3">
                    <Checkbox
                      onChange={(e) => handleCheck(e.target.checked)}
                      checked={disableTitulo}
                    >
                      No cuento con Titulo profesional.
                    </Checkbox>
                  </div>
                )}
              </div>

              <div className="md:flex gap-4">
                <Form.Item
                  label="Oficina / Dependencia"
                  name="idoficina"
                  initialValue={data ? data.idoficina : ""}
                  rules={[{ required: true, message: "La Oficina / Dependencia es requerida" }]}
                  className="w-full md:w-1/2"
                >
                  <Select
                    placeholder="Seleccione la Oficina / Dependencia"
                    // defaultValue={data ? data.idoficina : ""}
                  >
                    {oficinas.map((item) => (
                      <Option key={item.idoficina} value={item.idoficina}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="md:flex w-full">
                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <Form.Item
                    label="Nombres y apellidos del jefe inmediato"
                    name="nombrejefe"
                    className="w-full md:w-1/2"
                    initialValue={data ? data.nombrejefe : ""}
                    rules={[{ required: true, message: "El nombre es requerido" }]}
                    required
                  >
                    <Input placeholder="Nombre completo del jefe inmediato" />
                  </Form.Item>
                )}

                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <Form.Item
                    label="Número de celular del jefe inmediato"
                    name="nrocelularjefe"
                    className="w-full md:w-1/2 md:ml-3"
                    initialValue={data ? data.nrocelularjefe : ""}
                    rules={[{ required: true, message: "El nombre es requerido" }]}
                    required
                  >
                    <Input placeholder="952000000" />
                  </Form.Item>
                )}
              </div>
              
              {data.idtipoparticipacion === SHARED.ID_SUPERVISION && (
                <Form.Item
                  label="Lugar donde realizará la supervisión"
                  name="idlugarexamen"
                  initialValue={data ? data.idlugarexamen : ""}
                  rules={[{ required: true, message: "El lugar de examen es requerido" }]}
                  className="w-full md:w-1/2"
                >
                  <Select placeholder="Seleccione lugar de examen">
                    {lugarExamen.map((item) => (
                      <Option key={item.idlugarexamen} value={item.idlugarexamen}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              
            </Fragment>
          )}
          {data.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
            <Fragment>
              <Form.Item
                label="Código universitario"
                name="coduniversitario"
                className="w-full md:w-1/2 md:mr-3"
                initialValue={data ? data.coduniversitario : ""}
                rules={[{ required: true, message: "El código universitario es requerido" }]}
              >
                <Input placeholder="2018-000000" disabled />
              </Form.Item>

              {/* <Form.Item
                label="Facultad"
                name="idfacultad"
                initialValue={data ? data.idfacultad : ""}
                rules={[{ required: true, message: "La facultad es requerida" }]}
                className="w-full md:w-1/2 md:ml-3"
              >
                <Select placeholder="Seleccione la facultad" disabled>
                  {facultades.map((item) => (
                    <Option key={item.idfacultad} value={item.idfacultad}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item> */}
              
              {data.idtipoparticipacion === SHARED.ID_SUPERVISION && (
                <Form.Item
                  label="Lugar donde realizará la supervisión"
                  name="idlugarexamen"
                  initialValue={data ? data.idlugarexamen : ""}
                  rules={[{ required: true, message: "El lugar de examen es requerido" }]}
                  className="w-full md:w-1/2"
                >
                  <Select placeholder="Seleccione lugar de examen">
                    {lugarExamen.map((item) => (
                      <Option key={item.idlugarexamen} value={item.idlugarexamen}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              
            </Fragment>
          )}
          {/* </div> */}
          <div className="md:flex">
            {data.idtipoparticipante === SHARED.ID_DOCENTE && (
              <Fragment>
                <Form.Item
                  label="Departamento académico"
                  className="w-full md:w-1/2 md:mr-3"
                  name="iddepacademico"
                  rules={[{ required: true, message: "El Departamento académico es requerido" }]}
                  initialValue={data ? data.iddepacademico : ""}
                >
                  <Select
                    placeholder="Seleccione el Departamento académico"
                    // defaultValue={data ? data.iddepacademico : ""}
                  >
                    {departamentosAcademicos.map((item) => (
                      <Option key={item.iddepacademico} value={item.iddepacademico}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                
                {data.idtipoparticipacion === SHARED.ID_SUPERVISION && (
                  <Form.Item
                    label="Lugar donde realizará la supervisión"
                    name="idlugarexamen"
                    initialValue={data ? data.idlugarexamen : ""}
                    rules={[{ required: true, message: "El lugar de examen es requerido" }]}
                    className="w-full md:w-1/2"
                  >
                    <Select placeholder="Seleccione lugar de examen">
                      {lugarExamen.map((item) => (
                        <Option key={item.idlugarexamen} value={item.idlugarexamen}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                

                {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                  <Form.Item
                    label="Asignatura de su especialidad"
                    name="idasignatura"
                    initialValue={data ? data.idasignatura : ""}
                    rules={[
                      { required: true, message: "La asignatura de su especialidad es requerida" }
                    ]}
                    className="w-full md:w-1/2 md:ml-3"
                  >
                    <Select
                      placeholder="Seleccione la asignatura"
                      // defaultValue={data ? data.idoficina : ""}
                    >
                      {asignatura.map((item) => (
                        <Option key={item.idasignatura} value={item.idasignatura}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Fragment>
            )}

            {data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO && (
              <Fragment>
                {/* <Form.Item
                  label="Facultad"
                  name="idfacultad"
                  className="w-full md:w-1/2 md:mr-3"
                  rules={[{ required: true, message: "La facultad es requerida" }]}
                  initialValue={data ? data.idfacultad : ""}
                >
                  <Select
                    placeholder="Seleccione la facultad"
                    // defaultValue={data ? data.idfacultad : ""}
                  >
                    {facultades.map((item) => (
                      <Option key={item.idfacultad} value={item.idfacultad}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item> */}

                {/* <Form.Item
                  label="Oficina / Dependencia"
                  name="idoficina"
                  initialValue={data ? data.idoficina : ""}
                  rules={[{ required: true, message: "La Oficina / Dependencia es requerida" }]}
                  className="w-full md:w-1/2 md:mr-3"
                >
                  <Select
                    placeholder="Seleccione la Oficina / Dependencia"
                    // defaultValue={data ? data.idoficina : ""}
                  >
                    {oficinas.map((item) => (
                      <Option key={item.idoficina} value={item.idoficina}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item> */}
              </Fragment>
            )}
            {data.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
              <Fragment>
                <Form.Item
                  label="Escuela"
                  name="idcarrera"
                  initialValue={data ? data.idcarrera : ""}
                  className="w-full md:w-1/2 md:mr-3"
                  rules={[{ required: true, message: "La escuela es requerida" }]}
                >
                  <Select
                    placeholder="Seleccione la escuela"
                    disabled
                    // defaultValue={data ? data.idespecialidad : ""}
                  >
                    {carreras.map((item) => (
                      <Option key={item.idcarrera} value={item.idcarrera}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Semestre"
                  name="idsemestre"
                  rules={[{ required: true, message: "El semestre es requerido" }]}
                  initialValue={data ? data.idsemestre : ""}
                  className="w-full md:w-1/2 md:ml-3"
                >
                  <Select
                    placeholder="Seleccione el semestre"
                    disabled
                    // defaultValue={data ? data.idsemestre : ""}
                  >
                    {semestres.map((item) => (
                      <Option key={item.idsemestre} value={item.idsemestre}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Fragment>
            )}
          </div>

          {/* ================== Adjuntar archivos ================== */}
          {data.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
            <Form.Item
              name="urlDocumento"
              label={<p>ADJUNTAR FICHA DE MATRÍCULA (Escaneado) - FORMATO PDF - PESO MÁX. 10 MB</p>}
              className="mb-10"
              rules={[{ required: true, message: "La ficha de matrícula escaneada es requerida" }]}
              initialValue={data ? data.urlDocumento : ""}
            >
              <div className="flex justify-between">
                <Upload
                  {...uploadDocument("documento_identidad", data.nrodocumento)}
                  accept=".pdf"
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />} disabled={data?.isDocumentoOk}>
                    Añadir archivo
                  </Button>
                </Upload>

                <ShowAlertByUrlOk itHasUrl={data?.urlDocumento} isUrlOk={data?.isDocumentoOk} />
              </div>
            </Form.Item>
          )}

          {(data.idtipoparticipante === SHARED.ID_DOCENTE ||
            data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO) && (
            <Form.Item
              name="urlDocumento"
              label="ADJUNTAR DOCUMENTO DE IDENTIDAD (Escaneado por ambos lados en una hoja) - FORMATO PDF - PESO MÁX. 10 MB"
              className="mb-10"
              rules={[{ required: true, message: "El DNI escaneado es requerido" }]}
              initialValue={data ? data.urlDocumento : ""}
            >
              <div className="flex justify-between">
                <Upload
                  {...uploadDocument("documento_identidad", data.nrodocumento)}
                  accept=".pdf"
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />} disabled={data?.isDocumentoOk}>
                    Añadir archivo
                  </Button>
                </Upload>

                <ShowAlertByUrlOk itHasUrl={data?.urlDocumento} isUrlOk={data?.isDocumentoOk} />
              </div>
            </Form.Item>
          )}

          {data.idtipoparticipacion === SHARED.ID_INTERNAMIENTO &&
            (data.idtipoparticipante === SHARED.ID_DOCENTE ||
              data.idtipoparticipante === SHARED.ID_ADMINISTRATIVO) && (
              <Form.Item
                name="urlCurriculum"
                label={<p>ADJUNTAR EL CURRICULUM VITAE (MÁXIMO 10 FOLIOS)</p>}
                className="mb-10"
                initialValue={data ? data.urlCurriculum : ""}
              >
                <div className="flex justify-between">
                  <Upload
                    {...uploadDocument("carne_vacunacion", data.nrodocumento)}
                    accept=".pdf"
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />} disabled={data?.isCurriculumOk}>
                      Añadir archivo
                    </Button>
                  </Upload>

                  <ShowAlertByUrlOk itHasUrl={data?.urlCurriculum} isUrlOk={data?.isCurriculumOk} />
                </div>
              </Form.Item>
            )}

          <Form.Item
            name="urlDeclaracionJurada"
            label={
              <div className="flex">
                <p>
                  ADJUNTAR DECLARACION JURADA CON FIRMA Y HUELLA (Escaneado) - FORMATO PDF - PESO
                  MÁX. 10 MB
                </p>
                <Button type="link" onClick={() => descargarDeclaracionJurada()}>
                  Descargar plantilla
                </Button>
              </div>
            }
            className="mb-10"
            rules={[{ required: true, message: "La declaración jurada escaneada es requerida" }]}
            initialValue={data ? data.urlDeclaracionJurada : ""}
          >
            <div className="flex justify-between">
              <Upload
                {...uploadDocument("declaracion_jurada", data.nrodocumento)}
                accept=".pdf"
                maxCount={1}
              >
                <Button icon={<UploadOutlined />} disabled={data?.isDeclaracionJuradaOk}>
                  Añadir archivo
                </Button>
              </Upload>

              {/* <Button 
                onClick={descargarDeclaracionJurada}
                className="bg-grey-500 border-grey-500 text-grey-500 mb-3"
                >
                  Descargar formato de Declaración Jurada
              </Button> */}

              <ShowAlertByUrlOk
                itHasUrl={data?.urlDeclaracionJurada}
                isUrlOk={data?.isDeclaracionJuradaOk}
              />
            </div>
          </Form.Item>

          <Form.Item
            name="urlFoto"
            label="ADJUNTAR FOTO DEL ROSTRO (Fondo blanco)- Formato JPG -Resolución mínima de 300 dpi (240x288 pixeles de dimensión) y un tamaño máximo de 3 MB"
            className="mb-10"
            rules={[
              {
                required: true,
                message: "La Foto escaneada es requerida"
              }
            ]}
            initialValue={data ? data.urlFoto : ""}
          >
            <div className="flex justify-between">
              <Upload
                {...uploadDocument("foto_rostro", data.nrodocumento)}
                accept=".jpg"
                maxCount={1}
              >
                <Button icon={<UploadOutlined />} disabled={data?.isFotoOk}>
                  Añadir archivo
                </Button>
              </Upload>

              <ShowAlertByUrlOk itHasUrl={data?.urlFoto} isUrlOk={data?.isFotoOk} />
            </div>
          </Form.Item>

          <Form.Item
            name="acceptTerms"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(new Error("Es requerido aceptar los términos"))
              }
            ]}
            className="mb-12"
            initialValue={data ? data.acceptTerms : false}
          >
            <Checkbox>
              Estoy de acuerdo con toda la información registrada en el formulario, y declaro que
              todos los archivos adjuntados son una copia fidedigna de los documentos originales. En
              caso de falsedad documental, me someto a la aplicación de las Normas Legales
              correspondientes de la Universidad y a las sanciones que hubiere lugar.
            </Checkbox>
          </Form.Item>

          <Form.Item className="text-center">
            <Button className="px-10" type="primary" htmlType="submit">
              Guardar cambios
            </Button>
          </Form.Item>
        </Form>
      </div>

      <ButtonHelp />
    </Fragment>
  );
}

export default Formulario;
